import '../sass/map.scss';

(() => {
    const $blocks = document.querySelectorAll('.map');

    $blocks?.forEach($block => {
        const $map = $block.querySelector('.map__map');

        (g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
            key: "YOUR_API_KEY",
            v: "weekly",
        });

        const initMap = async () => {
            if (!$map) return;
            
            const lat = $map?.dataset?.lat ? parseFloat($map.dataset.lat) : null;
            const lng = $map?.dataset?.lng ? parseFloat($map.dataset.lng) : null;

            const { Map } = await google.maps.importLibrary("maps");

            const map = new Map($map, {
                center: { lat: lat, lng: lng },
                zoom: 12,
            });

            const marker = new google.maps.Marker({
                position: { lat: lat, lng: lng },
                map,
            });
        };

        initMap();
    });
})();
